'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = validateBySchema;

var _transform = require('lodash/transform');

var _transform2 = _interopRequireDefault(_transform);

var _codevTraverse = require('codev-traverse');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var middleware = function middleware(_ref) {
  var validator = _ref.validator,
      contents = _ref.contents;
  return function () {
    return function (next) {
      return function (value) {
        var result = validator ? validator(value) : undefined;

        var childrenResult = next(value);
        if (childrenResult === undefined) return result;

        var fallback = void 0;
        return (0, _transform2.default)(childrenResult, function (pre, val, key) {
          var subschema = contents[key] || fallback;
          fallback = subschema;

          if (!subschema || !subschema.contents) {
            Object.assign(pre, _defineProperty({}, key, val));
          } else {
            (0, _transform2.default)(val, function (p, v, k) {
              if (k === '$root') {
                Object.assign(p, _defineProperty({}, key, v));
              } else {
                Object.assign(p, _defineProperty({}, key + '.' + k, v));
              }
            }, pre);
          }
        }, { $root: result });
      };
    };
  };
};

// ISSUE add `server`, `user` in context?
function validateBySchema(schema) {
  return function (value) {
    return (0, _codevTraverse.traverse)(schema)(middleware)()(value);
  };
}


//////////////////
// WEBPACK FOOTER
// ./~/coact/utils/validation/validateBySchema.js
// module id = 1709
// module chunks = 0